import React, { ReactElement, useState } from 'react';
import AdminTemplate from 'components/templates/AdminTemplate';
import { Grid, Typography, Button, TextField, CircularProgress } from '@material-ui/core';
import useCustomSnackbar from 'hooks/useCustomSnackbar';

import OrderTrackingList from 'components/organisms/OrderTrackingList';

import useOrderTracking from 'hooks/useOrderTracking';
import { IOrderProducts } from 'interfaces/orderTracking.interface';

export default function OrderTracking(): ReactElement {
  const [isLoading, setIsLoading] = useState(false);
  const [order, setOrder] = useState<IOrderProducts[]>([]);
  const [orderNumber, setOrderNumber] = useState<string>('');
  const [validateOrder, setValidateOrder] = useState({
    haveErrors: false,
    errorMessage: ''
  });
  const { showNotistack } = useCustomSnackbar();

  const { getOrderTrackingByOrderNumber } = useOrderTracking();

  const handleGetOrderByNumber = (orderNumber: string) => {
    setIsLoading(true);
    getOrderTrackingByOrderNumber(orderNumber)
      .then((orderTracking) => {
        setOrder(orderTracking);
        if (!orderTracking) {
          showNotistack({ message: 'Número de paquete incorrecto' });
        }
      })
      .catch(() => {
        // TODO redireccionar en 403
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!orderNumber) {
      setValidateOrder({
        haveErrors: true,
        errorMessage: 'Este campo es obligatorio'
      });
      return;
    }
    handleGetOrderByNumber(orderNumber);
  };
  return (
    <AdminTemplate>
      <React.Fragment>
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography variant="h5" component="h1" align="center">
              Rastreo de Pedidos
            </Typography>
          </Grid>
        </Grid>
        <form onSubmit={handleSubmit}>
          <Grid item xs={10} sm={10} md={12}>
            <Grid container direction="row" spacing={2} justify="flex-end" alignItems="center">
              <Grid item xs={12} sm={12} md={2}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Número del pedido"
                  name="numberOrder"
                  autoComplete="numberOrder"
                  onChange={(e) => {
                    if (e.target.value !== '') {
                      setValidateOrder({
                        haveErrors: false,
                        errorMessage: ''
                      });
                    }
                    setOrderNumber(e.target.value);
                  }}
                  autoFocus
                  disabled={isLoading}
                  error={validateOrder.haveErrors}
                  helperText={validateOrder.errorMessage}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Button
                disabled={isLoading}
                type="submit"
                variant="contained"
                color="primary"
                style={{ height: 55, marginRight: 20, marginTop: 5 }}
              >
                {isLoading ? <CircularProgress size={24} /> : ''} Buscar
              </Button>
              <Grid item xs={12} sm={12} md={12}>
                <OrderTrackingList order={order} isLoading={isLoading} />
              </Grid>
            </Grid>
          </Grid>
        </form>
      </React.Fragment>
    </AdminTemplate>
  );
}
